import { Box, Typography } from "@mui/material";
import { CALIBRATE_FONT_FAMILY_ACCENT } from "components/hoc/Theme";
import DarkCtaButton from "components/common/DarkCtaButton";

interface CTABannerProps {
  onContactClick: () => void;
}

export default function CTABanner({ onContactClick }: CTABannerProps) {
  return (
    <Box
      sx={{
        width: "100%",
        py: 4,
        px: 2,
        backgroundColor: "rgba(0,0,0,0.05)",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: 1.5,
        borderRadius: "8px",
        minHeight: "112px",
      }}
    >
      <Typography
        variant="body1"
        sx={{
          fontFamily: CALIBRATE_FONT_FAMILY_ACCENT,
          fontSize: "1rem",
          color: "text.primary",
          textAlign: "center",
        }}
      >
        Want to talk to our team about partnerships?
      </Typography>

      <DarkCtaButton
        tone="solidLight"
        onClick={onContactClick}
        sx={{ fontSize: "0.9375rem", fontWeight: 500, px: 3, py: 1 }}
      >
        Contact Our Partnership Team
      </DarkCtaButton>
    </Box>
  );
}
